var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActionRequired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.6,
    height: 20,
    viewBox: "0 0 18.6 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(-19.999 -19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34728",
    "data-name": "Path 34728",
    d: "M17.524,16.651l.489-.271,1.119-9.71L12,4.124,4.869,6.669l1.119,9.71.474.263L12,4.21Zm-1.1.609h-.8l-1.169-2.92H9.523L8.354,17.26H7.576L12,19.713ZM12,2l9.3,3.32L19.882,17.63,12,22,4.119,17.63,2.7,5.32Zm1.7,10.54L12,8.45l-1.7,4.09Z",
    transform: "translate(17.299 17)",
    fill: "#575757"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionRequired);
export default __webpack_public_path__ + "static/media/actionRequired.7636f9820af3050383598056045cdf0e.svg";
export { ForwardRef as ReactComponent };